import { useLocation } from "react-router-dom"
import ConnectRequestForInformation from "./ConnectRequestForInformation"

export default function ConnectRequestForInformationWithRefresh() {

    // See: https://github.com/remix-run/react-router/issues/7416
    const location = useLocation()
    console.log('ConnectRequestForInformationWithRefresh location', location)
    return (
        <ConnectRequestForInformation key={location.key} />
    )
}